/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { ArticleField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { postBy, formatArticleError } from '@utils';

const RelatedArticleModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related article"
    subtitle="Find an article related to this article"
    okText="ADD ARTICLE"
    onSubmit={({ article }) => onSubmit(article)}
  >
    <ArticleField
      label="Choose an article"
      name="article"
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Article is required' }]}
    />
  </RelatedContentModal>
);

const Item = (article) => {
  if (article instanceof Error) {
    const error = article;
    return <InfoItem>{formatArticleError(error)}</InfoItem>;
  }
  return (
    <InfoItem image={article.featuredImage} description={postBy(article)}>
      {article.title}
    </InfoItem>
  );
};

RelatedArticleModal.Item = Item;

export default RelatedArticleModal;
